import { Request } from './Request';
import { SearchUsersRequestResponse } from '@/data/models/SearchUsersRequestResponse';

export class SearchUsersRequest extends Request<SearchUsersRequestResponse> {
  method = 'GET';
  url = '';

  constructor(searchValue: string) {
    super();

    this.url = '/user?reason=search&query=' + searchValue;
  }

  params: {
    offset?: number;
    pageSize?: number;
  } = {
    offset: undefined,
    pageSize: undefined,
  };
}
